import React, {useEffect, useState} from 'react';
import {PageTitle} from '../../../../../_metronic/layout/core';
import VideoCard from '../VideosPage/components/VideoCard';
import {SampleVideos} from '../VideosPage/videos.data';
import {parseError, sortByProp} from '../../../../../shared/utils';
import {ErrorPlaceholder} from '../../../../../shared/components/ErrorPlaceholder';
import {LoadingPlaceholder} from '../../../../../shared/components/LoadingPlaceholder';
import {Dialog} from 'primereact/dialog';
import VideoDialog from '../VideosPage/components/VideoDialog';
import TemplateForm from './components/TemplateForm';
import clsx from 'clsx';
import {useAuth} from '../../../auth';
import {getAllTemplates} from '../../vidoes.api';
import {Video} from '../../vidoes.types';
import {useCardsSelection} from '../../../models-management/pages/models-list/core/CardsSelectionProvider';
import {TemplatesSelectionOptions} from './components/TemplatesSelectionOptions';
import HasPermission from '../../../auth/HasPermission';
import useTemplatesStore from './templates.store';
import {TemplatesFilters, templatesStatuses} from './components/TemplatesFilters';
import {TemplatesSorting} from './components/TemplatesSorting';
import {usePermissionChecker} from '../../../admin/pages/roles/hooks/permission-checker';

const Templates = () => {
  const [showWindow, setShowWindow] = useState(false);
  const {currentUser} = useAuth();
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [templates, setTemplates] = useState<Video[]>([]);
  const {count: selectedCount, clearAll} = useCardsSelection();
  const {updateFilters, filters} = useTemplatesStore();

  const {hasPermission} = usePermissionChecker();

  const showPublishedOnly =
    !currentUser?.is_super_admin && hasPermission('menu.published-templates');

  const fetchData = async () => {
    try {
      setLoading(true);

      const res = await getAllTemplates({});

      let temps: any[] = res.data?.templates || [];

      if (filters.filter?.status)
        temps = temps.filter(
          (d) => d.published === (filters.filter?.status === 'published' ? true : false)
        );

      temps = sortByProp(temps, filters.sort + '', filters.order);

      if (showPublishedOnly) temps = temps.filter((t: Video) => t.published === true);

      setTemplates(temps);

      setLoading(false);
    } catch (error: any) {
      setError(parseError(error));
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();

    return () => clearAll();
  }, []);

  useEffect(() => {
    fetchData();
  }, [filters]);

  if (error) return <ErrorPlaceholder error={error} />;

  return (
    <div>
      <PageTitle breadcrumbs={[{title: '3D Experiences', path: 'videos', isActive: false}]}>
        Templates
      </PageTitle>

      {loading && <LoadingPlaceholder />}
      {!loading && (
        <div className='app-container container-fluid'>
          <header className='d-flex justify-content-between align-items-center mb-5'>
            <div className='d-flex align-items-center'>
              <h2>Templates for 3D Experiences</h2>

              {!showPublishedOnly && selectedCount > 0 && (
                <TemplatesSelectionOptions templates={templates} onReload={() => fetchData()} />
              )}
            </div>

            <div className='tools d-flex'>
              <ul className='nav nav-pills me-6 mb-2 mb-sm-0'>
                <li className='nav-item m-0'>
                  <TemplatesSorting />
                </li>
                {!showPublishedOnly && (
                  <li className='nav-item m-0'>
                    <TemplatesFilters />
                  </li>
                )}
              </ul>

              <HasPermission code='templates.create'>
                <button
                  onClick={() => setShowWindow(true)}
                  className='btn btn-primary btn-sm fw-bold me-2'
                >
                  <span>Add New Template</span>
                </button>
              </HasPermission>
            </div>
          </header>

          <div className='row g-10'>
            {templates.map((video) => (
              <div className='col-3'>
                <VideoCard key={video.id} video={video} isTemplate onUpdate={fetchData} />
              </div>
            ))}
          </div>
        </div>
      )}

      <Dialog
        modal
        dismissableMask
        closable={false}
        visible={showWindow}
        onHide={() => setShowWindow(false)}
      >
        <TemplateForm
          submitComplete={(ok) => {
            setShowWindow(false);
            ok && fetchData();
          }}
        />
      </Dialog>
    </div>
  );
};

export default Templates;
